export interface ISoundPropertiesConfig {
    duration: number;
    loop: boolean;
    panning?: number;
    priority: number;
    size: number;
    sourcePath: string;
    volume: number;
    classifier?: string;
    duck?: [];
}